//import React components
import {useEffect} from "react";
import {useLocation} from "react-router-dom";


//import components
import PageContainer from "./components/PageContainer";
import {scroller} from "react-scroll";


//callable functions
//font awesome
import {library} from '@fortawesome/fontawesome-svg-core';
import {fab} from '@fortawesome/free-brands-svg-icons';
import {fas} from "@fortawesome/free-solid-svg-icons";
import {far} from "@fortawesome/free-regular-svg-icons";
import {Col} from "reactstrap";
import TopNav from "../modules/navigation/top/TopNav";
import SideNav from "../modules/navigation/left/SideNav";
import {useSettingStore} from "../context/settings";

library.add(fab, fas, far);


export default function PageLayout({...props}) {
  const location = useLocation();
  const navbarExtended = useSettingStore((state) => state.navbarExtended);


  useEffect(() => {
    if (location.hash) {
      const scrollLocation = location.hash.substring(1, location.hash.length);
      scroller.scrollTo(scrollLocation, {
        duration: 0,
        delay: 0,
        smooth: false,
        offset: scrollLocation === "termsOfPurchase" ? -230 : -100,
      })
    } else {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }
  }, [location.hash, location.pathname]);

  return (
    <>
      <div className={navbarExtended ?
        "page"
        :
        "page--min"
      }>
        <TopNav
          className={"topNav"}/>
        <PageContainer>
          <Col
            className={"sideNav"}
            md="auto"
          >
            <SideNav/>
          </Col>

          <Col
            className={"page_container"}
            md="fill"
          >
            {props.children}
          </Col>
        </PageContainer>
      </div>
      {/*<ScrollToTop/>*/}
    </>
  )
}
